<template>
  <div>
    <section>
      <h1 class="is-size-5 has-margin-bottom-small">Radiological attributes</h1>
      <div class="is-padded-small">
        <key-value-table :items="tableItems" />
      </div>
      <div class="is-padded-small">
        <b-table
          :data="tableData"
          :columns="columns"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import KeyValueTable from '@/components/structures/KeyValueTable'

export default {
  components: {
    KeyValueTable
  },
  data () {
    return {
      columns: [
        {
          field: 'name',
          label: 'Type'
        },
        {
          field: 'energy',
          label: 'Energy'
        },
        {
          field: 'intensity',
          label: 'Intensity'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedAgent']),
    tableItems () {
      /* eslint-disable */
      const { decay_product, physical_halflife, physical_halflife_unit, biological_halflife, biological_halflife_unit, ld50, molecular_weight, structure, lel, uel, odor_threshold, lc50, acgih_8h, acgih_stel, idlh, proton_affinity, hazard_id } = this.selectedAgent
      return [
        { label: 'Decay product', value: decay_product },
        { label: 'Physical halflife', value: physical_halflife ? `${physical_halflife} ${physical_halflife_unit}(s)` : null },
        { label: 'Biological halflife', value: biological_halflife ? `${biological_halflife} ${biological_halflife_unit}(s)` : null },
        { label: 'LD50', value: ld50 },
        { label: 'Molecular weight', value: molecular_weight, unit: 'g/mol' },
        { label: 'Structure', value: structure },
        { label: 'Lower Explosive Limit (LEL)', value: lel, unit: '%' },
        { label: 'Upper Explosive Limit (UEL)', value: uel, unit: '%' },
        { label: 'Odor threshold', value: odor_threshold, unit: 'ppm' },
        { label: 'LC50', value: lc50, unit: 'ppm' },
        { label: 'ACGIH 8h', value: acgih_8h, unit: 'ppm' },
        { label: 'ACGIH STEL', value: acgih_stel, unit: 'ppm' },
        { label: 'IDLH', value: idlh, unit: 'ppm' },
        { label: 'Proton Affinity', value: proton_affinity, unit: 'kJ/mole' },
        { label: 'Hazard ID Number', value: hazard_id },
      ]
    },
    tableData () {
      return [
        { name: 'Alpha', energy: this.selectedAgent.alpha_energy, intensity: this.selectedAgent.alpha_intensity },
        { name: 'Beta', energy: this.selectedAgent.beta_energy, intensity: this.selectedAgent.beta_intensity },
        { name: 'Gamma', energy: this.selectedAgent.gamma_energy, intensity: this.selectedAgent.gamma_intensity },
        { name: 'X-Ray', energy: this.selectedAgent.xray_energy, intensity: this.selectedAgent.xray_intensity },
      ].map(row => {
        Object.keys(row).forEach(key => {
          row[key] = row[key] || '-'
        })
        return row
      })
    }
  }
}
</script>
